import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'reactstrap'
import { nanoid } from 'nanoid'

const SectionAppConfig = ({ title, children, count, isOpen, setActivePanel, panelName }) => {
  const id = nanoid()
  return (
    <Fragment>
      <button className={`list-group-item w-100 h-100 ${isOpen ? 'bg-light' : ''}`} onClick={() => { isOpen ? setActivePanel('') : setActivePanel(panelName) }} data-cy={title} aria-controls={`collapsableDiv-${id}`} aria-expanded={isOpen}>
        <div className='d-flex justify-content-between'>
          <div className='d-flex align-items-center'>
            <p className='mb-0 me-4 h4'>{title}</p>
            <span className='text-muted h6 mb-0'>{count} {count !== 1 ? 'records' : 'record'} </span>
          </div>
          <span className={`fas ${isOpen ? 'fa-chevron-down' : 'fa-chevron-up'} pt-1 pe-2`} style={{ fontSize: '20px' }} />
        </div>
      </button>

      <div id={`collapsableDiv-${id}`}>
        <Collapse isOpen={isOpen} className='collapse-nav'>
          {children}
        </Collapse>
      </div>

    </Fragment>
  )
}

SectionAppConfig.propTypes = {
  panelName: PropTypes.string,
  setActivePanel: PropTypes.func,
  count: PropTypes.number,
  isOpen: PropTypes.bool,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  defaultOpen: PropTypes.bool
}

export default SectionAppConfig
